module.exports = __webpack_public_path__ + "static/media/45_tn.3493d788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/45_tn.jpg
// module id = 533
// module chunks = 0